import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Alert, AlertTitle } from '@mui/material';
import cats from '../../containers/catalogs';
import docs from '../../containers/documents';
import srvs from '../../containers/services';
import logicaSrvs from '../../containers/logica';
import Home from './home';
import ListersSelectors from '../../const/listers_selectors';
import Service from './servicesPage';
import Logica from './logicaPage';
import CalculateOfContractsPage from './calculateOfContractsPage';
import ReportPanel from '../../containers/gatherer_reports';
import NewReportEditor from '../../containers/basicReport';
import DictPage from './dictsPage';
import AddrPage from './addrpage';
import SubscriptionsPage from './subscriptionsPage';
import LandsPage from './landsPage';
import { LinkComponent } from '../windowsManager';
import ResetPassword from '../Login/resetPassword';
import HouseholdPage from './household';

function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={Home} />
      {Object.keys(ListersSelectors).map((model) => (
        Object.keys(ListersSelectors[model]).map((m) => (
          <Route
            exact
            key={`${model}-${m}`}
            path={ListersSelectors[model][m].frontend}
            render={() => (
              <LinkComponent
                component={ListersSelectors[model][m].lister}
                title={`Список "${ListersSelectors[model][m].backend}" `}
              />
            )}
          />
        ))
      ))}

      <Route
        exact
        path="/logica/"
        render={() => (
          <LinkComponent
            component={Logica}
            title={'Робота з "Logica"'}
          />
        )}
      />

      <Route
        exact
        path="/logica/login/"
        component={logicaSrvs.LoginInLogica.Editor}
        render={() => (
          <LinkComponent
            component={logicaSrvs.LoginInLogica.Editor}
            title="Авторизація в логіці"
          />
        )}
      />
      <Route
        exact
        path="/logica/getTreasureFiles/"
        component={logicaSrvs.ImportTreasureFiles.Editor}
        render={() => (
          <LinkComponent
            component={logicaSrvs.ImportTreasureFiles.Editor}
            title="Завантаження казначейских файлів"
          />
        )}
      />
      <Route
        exact
        path="/logica/getSTAFiles/"
        component={logicaSrvs.ImportSTAFiles.Editor}
        render={() => (
          <LinkComponent
            component={logicaSrvs.ImportSTAFiles.Editor}
            title="Завантаження податкових файлів"
          />
        )}
      />
      <Route
        exact
        path="/landSessionXml/"
        component={srvs.LandSessionXml.Editor}
        render={() => (
          <LinkComponent
            component={srvs.LandSessionXml.Editor}
            title="XML Рішеннь сесії"
          />
        )}
      />
      <Route
        exact
        path="/landTaxCalculation/"
        component={srvs.LandTaxCalculaion.Editor}
        render={() => (
          <LinkComponent
            component={srvs.LandTaxCalculaion.Editor}
            title="Розрахунок податку на землю"
          />
        )}
      />

      <Route exact path="/cat/" component={DictPage} />
      <Route
        exact
        path="/addr/"
        render={() => (
          <LinkComponent
            component={AddrPage}
            title="Адресний класифікатор"
          />
        )}
      />
      <Route
        exact
        path="/treasure_subscriptions/"
        render={() => (
          <LinkComponent
            component={SubscriptionsPage}
            title="Виписки"
          />
        )}
      />

      <Route
        exact
        path="/accounting_lands/"
        render={() => (
          <LinkComponent
            component={LandsPage}
            title="Облік земельних ділянок"
          />
        )}
      />

      <Route
        exact
        path="/household/"
        render={() => (
          <LinkComponent
            component={HouseholdPage}
            title="Домогосподарства"
          />
        )}
      />

      <Route
        exact
        path="/cat/householdMembers/:id/:idp"
        render={() => (
          <LinkComponent
            component={cats.householdMembers.Editor}
            title="cat/householdMembers!!!"
          />
        )}
      />

      {Object.keys(cats).map((key) => {
        if (!cats[key].md) throw new Error(`Ключ cats.${key}.md not found`);
        if (!cats[key].md.frontend) throw new Error(`Ключ cats.${key}.md.frontend not found`);
        return (
          <Route
            key={cats[key].md.frontend}
            exact
            path={`${cats[key].md.frontend}:id`}
            render={() => (
              <LinkComponent
                component={cats[key].Editor}
                title={`${cats[key].md.frontend}:id`}
              />
            )}
          />
        );
      })}

      {Object.keys(docs).map((key) => {
        if (!docs[key].md) throw new Error(`Ключ docs.${key}.md not found`);
        if (!docs[key].md.frontend) throw new Error(`Ключ docs.${key}.md.frontend not found`);
        return (
          <Route
            key={docs[key].md.frontend}
            exact
            path={`${docs[key].md.frontend}:id`}
            render={() => (
              <LinkComponent
                component={docs[key].Editor}
                title={`${docs[key].md.frontend}:id`}
              />
            )}
          />
        );
      })}

      <Route exact path="/calcofcontr/" component={CalculateOfContractsPage} />

      <Route exact path="/srv/" component={Service} />

      <Route
        exact
        path="/srv/contractprintform/"
        render={() => (
          <LinkComponent
            component={srvs.ContractPrintForm.Editor}
            title="Отримання друкованої форми"
          />
        )}
      />

      <Route
        exact
        path="/srv/calculate_payments/"
        render={() => (
          <LinkComponent
            component={srvs.CalculatePayments.Editor}
            title="Розрахунок платежів"
          />
        )}
      />
      <Route
        exact
        path="/srv/exchange/"
        render={() => (
          <LinkComponent
            component={srvs.exchange.Editor}
            title="Імпорт виписки"
          />
        )}
      />
      <Route
        exact
        path="/srv/reload_contracts/"
        render={() => (
          <LinkComponent
            component={srvs.ContractsReload.Editor}
            title="Перезаповнити контракти"
          />
        )}
      />
      <Route
        exact
        path="/srv/parse-comments/"
        render={() => (
          <LinkComponent
            component={srvs.CommentsReparse.Editor}
            title="Перечитати платників з примітки (по транзитним разункам)"
          />
        )}
      />
      <Route
        exact
        path="/srv/parse-payers/"
        render={() => (
          <LinkComponent
            component={srvs.PayersParser.Editor}
            title="Перезаповнити гендерні ознаки платнків"
          />
        )}
      />
      <Route
        exact
        path="/srv/send-message/"
        render={() => (
          <LinkComponent
            component={srvs.SendMessage.Editor}
            title="Надіслати повідомлення користувачам"
          />
        )}
      />

      <Route
        exact
        path="/srv/unite-payers/"
        render={() => (
          <LinkComponent
            component={srvs.UnitePayers.Editor}
            title="Замінити платника"
          />
        )}
      />
      <Route
        exact
        path="/srv/master/"
        render={() => (
          <LinkComponent
            component={srvs.Master.Editor}
            title="Помічник обробки виписок"
          />
        )}
      />
      <Route
        exact
        path="/srv/remarks-processing/"
        render={() => (
          <LinkComponent
            component={srvs.RemarksProcessing.Editor}
            title="Обробка зауважень"
          />
        )}
      />
      <Route
        exact
        path="/srv/skd-master/"
        render={() => (
          <LinkComponent
            component={srvs.SKDMaster.Editor}
            title="SKDMaster"
          />
        )}
      />
      <Route
        exact
        path="/srv/role_management/"
        render={() => (
          <LinkComponent
            component={srvs.RoleManagement.Editor}
            title="Редагування ролей користувачів"
          />
        )}
      />
      <Route
        exact
        path="/srv/group_management/"
        render={() => (
          <LinkComponent
            component={srvs.GroupManagement.Editor}
            title="Редлагування груп користувачів"
          />
        )}
      />
      <Route
        exact
        path="/srv/disabled_kdb/"
        render={() => (
          <LinkComponent
            component={srvs.DisabledKdb.Editor}
            title="Відключені КДБ"
          />
        )}
      />
      <Route
        exact
        path="/srv/indexing_contracts/"
        render={() => (
          <LinkComponent
            component={srvs.IndexingContracts.Editor}
            title="Розрахунок індексації орендної плати"
          />
        )}
      />
      <Route
        exact
        path="/srv/loadGRKSubs/"
        render={() => (
          <LinkComponent
            component={srvs.LoadGRKSubscription.Editor}
            title="Завантаження виписки ГРК"
          />
        )}
      />
      <Route
        exact
        path="/srv/print_invoices/"
        render={() => (
          <LinkComponent
            component={srvs.PrintInvoice.Editor}
            title="Друк рахунків за оренду комунального майна"
          />
        )}
      />
      <Route
        exact
        path="/srv/load_debts/"
        render={() => (
          <LinkComponent
            component={srvs.LoadDebts.Editor}
            title="Завантаження даних за боржниками з файлу у форматі Excel"
          />
        )}
      />

      <Route
        exact
        path="/grep"
        render={() => (
          <LinkComponent
            component={ReportPanel}
            title="Звіти"
          />
        )}
      />
      <Route
        exact
        path="/grep/:id"
        render={() => (
          <LinkComponent
            component={NewReportEditor}
            title="Звіт"
          />
        )}
      />
      <Route exact path="/resetPassword/:id" component={ResetPassword} />

      <Route>
        <div>Помилились?</div>
        <Alert severity="warning">
          <AlertTitle> Помилились адресою?</AlertTitle>
          Ви запросили щось таке, чого в нас немає
        </Alert>

      </Route>
    </Switch>
  );
}

export default Routes;
